// @ts-nocheck
import * as Types from '../../../gql/generated/graphql.gen';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSettingsPagesFamilyCustomerQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSettingsPagesFamilyCustomerQuery = { __typename?: 'Query', familyCustomer: { __typename?: 'FamilyCustomer', id?: number | null, uuid: string, familyCustomerStatus?: { __typename?: 'FamilyCustomerStatus', uuid: string, name?: string | null } | null, familyCustomerContractedPlans?: Array<{ __typename?: 'FamilyCustomerContractedPlan', uuid: string, contractedAt?: string | null, isActive?: boolean | null, subscriptionInfo?: { __typename?: 'SubscriptionInfo', name: string } | null }> | null } };


export const GetSettingsPagesFamilyCustomerDocument = gql`
    query getSettingsPagesFamilyCustomer {
  familyCustomer {
    id
    uuid
    familyCustomerStatus {
      uuid
      name
    }
    familyCustomerContractedPlans {
      uuid
      contractedAt
      isActive
      subscriptionInfo {
        name
      }
    }
  }
}
    `;

/**
 * __useGetSettingsPagesFamilyCustomerQuery__
 *
 * To run a query within a React component, call `useGetSettingsPagesFamilyCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsPagesFamilyCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsPagesFamilyCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSettingsPagesFamilyCustomerQuery(baseOptions?: Apollo.QueryHookOptions<GetSettingsPagesFamilyCustomerQuery, GetSettingsPagesFamilyCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettingsPagesFamilyCustomerQuery, GetSettingsPagesFamilyCustomerQueryVariables>(GetSettingsPagesFamilyCustomerDocument, options);
      }
export function useGetSettingsPagesFamilyCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettingsPagesFamilyCustomerQuery, GetSettingsPagesFamilyCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettingsPagesFamilyCustomerQuery, GetSettingsPagesFamilyCustomerQueryVariables>(GetSettingsPagesFamilyCustomerDocument, options);
        }
export function useGetSettingsPagesFamilyCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSettingsPagesFamilyCustomerQuery, GetSettingsPagesFamilyCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSettingsPagesFamilyCustomerQuery, GetSettingsPagesFamilyCustomerQueryVariables>(GetSettingsPagesFamilyCustomerDocument, options);
        }
export type GetSettingsPagesFamilyCustomerQueryHookResult = ReturnType<typeof useGetSettingsPagesFamilyCustomerQuery>;
export type GetSettingsPagesFamilyCustomerLazyQueryHookResult = ReturnType<typeof useGetSettingsPagesFamilyCustomerLazyQuery>;
export type GetSettingsPagesFamilyCustomerSuspenseQueryHookResult = ReturnType<typeof useGetSettingsPagesFamilyCustomerSuspenseQuery>;
export type GetSettingsPagesFamilyCustomerQueryResult = Apollo.QueryResult<GetSettingsPagesFamilyCustomerQuery, GetSettingsPagesFamilyCustomerQueryVariables>;